import React from "react";
import { PageAsCardFragment } from "types/graphql-types";
import { BackgroundColor } from "types/componentBackground";
import AsCardSlide, { AsCardSlideProps } from "./AsCardSlide";

interface SanityPageCardProps {
  page: PageAsCardFragment;
  cardBackgroundColor?: BackgroundColor;
  imageRatio?: AsCardSlideProps["imageRatio"];
}

const SanityPageCard: React.FC<
  React.PropsWithChildren<SanityPageCardProps>
> = ({ page, cardBackgroundColor = "neutral05", imageRatio }) => {
  if (!page?.card) return null;

  return (
    <AsCardSlide
      card={page.card}
      fullPath={page.fullPath}
      cardBackgroundColor={cardBackgroundColor}
      trackingName={page.metadata?.tracking?.name}
      imageRatio={imageRatio}
    />
  );
};

export default SanityPageCard;
